import React from 'react'

import BaseSkeleton from 'components/Skeleton/BaseSkeleton'
import { SkeletonContent, SkeletonRow, SkeletonRows } from './styled'

export default function NotificationListSkeleton({ label }) {
    return (
        <SkeletonRows aria-label={label}>
            {Array.from({ length: 5 }).map((_, index) => (
                <SkeletonRow key={index}>
                    <BaseSkeleton circle height={7} width={7} />
                    <SkeletonContent>
                        <BaseSkeleton height={10} width={92} />
                        <BaseSkeleton height={20} width="48%" />
                        <BaseSkeleton height={14} width="76%" />
                    </SkeletonContent>
                    <BaseSkeleton height={12} width={58} />
                </SkeletonRow>
            ))}
        </SkeletonRows>
    )
}
